import React, { useEffect, useRef, useState } from "react";
import { Card, CardMedia, CardContent, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./HighlightsSectionLP.css";
import scaLogo from "../../../assets/Images/Logos/SCALogo.png";

const HighlightsSectionLP = () => {
  const [imageScrolled, setImageScrolled] = useState(false);
  const [textScrolled, setTextScrolled]   = useState(false);
  const imageRef = useRef(null);
  const textRef  = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries, o) => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          if (e.target === imageRef.current) {
            setImageScrolled(true);
            o.unobserve(e.target);
          }
          if (e.target === textRef.current) {
            setTextScrolled(true);
            o.unobserve(e.target);
          }
        });
      },
      { threshold: 0 }
    );
    [imageRef, textRef].forEach(r => r.current && obs.observe(r.current));
    return () => obs.disconnect();
  }, []);

  const theme  = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const navigateClickHandler = () => {
    navigate('/Highlights');
  }

  return (
    <Card
      className="HighlightsCard"
      sx={{
        backgroundColor: "#FFD700",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
        boxShadow: "none"
      }}
      onClick={navigateClickHandler}
    >
      <div
        ref={imageRef}
        className={`scrollFromLeft ${imageScrolled ? "scrolled" : ""}`}
        style={{
          borderRight: isMdUp ? "2px solid #000f9b" : "none",
          flex: isMdUp ? "0 0 30%" : "none"
        }}
      >
        <CardMedia
          component="img"
          image={scaLogo}
          alt="Saint Catherine Academy logo"
          sx={{
            display: "block",
            margin: "auto",
          }}
        />
      </div>

      <div
        ref={textRef}
        className={`scrollFromRight ${textScrolled ? "scrolled" : ""}`}
        style={{ flex: isMdUp ? "1 1 70%" : "none" }}
      >
        <CardContent sx={{ padding: { xs: 2, md: 4 } }}>
          <Typography component="h1" className="highLandingLabel">
            Student Highlights Page
          </Typography>
          <Typography component="p" className="highLabel">
            The Language Department offers a rich, four-year sequence designed to
            build confident, culturally aware communicators. Throughout the
            four-year course, students will take courses in English language,
            Literature, and French, moving from foundation courses that emphasize
            everyday conversation and essential grammar to advanced concepts that
            explore literature, film, and current events. Literature courses will
            move from modern short stories, a variety of poetry, local Belize
            selections, rich Caribbean authors, and powerful British Literature
            extracts. Each level layers listening, speaking, reading, and writing
            skills while integrating authentic media. The upper level completes
            the CSEC English A syllabus. All courses foster global perspectives,
            critical thinking, and the interpersonal skills needed for success
            beyond the classroom by developing a disposition for lifetime
            learning while integrating all Mercy core values – educational
            courage, compelled by mercy, inspiration by faith, principled
            leadership, and a voice for dignity and respect.
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
};

export default HighlightsSectionLP;
